/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateContactInfoDto } from './UpdateContactInfoDto';
import {
    UpdateContactInfoDtoFromJSON,
    UpdateContactInfoDtoFromJSONTyped,
    UpdateContactInfoDtoToJSON,
} from './UpdateContactInfoDto';

/**
 * 
 * @export
 * @interface AdminUpdateBranchDto
 */
export interface AdminUpdateBranchDto {
    /**
     * Branch name
     * @type {string}
     * @memberof AdminUpdateBranchDto
     */
    branchName?: string;
    /**
     * Branch currency
     * @type {string}
     * @memberof AdminUpdateBranchDto
     */
    currency?: AdminUpdateBranchDtoCurrencyEnum;
    /**
     * Whether the branch is within a delivery zone
     * @type {boolean}
     * @memberof AdminUpdateBranchDto
     */
    canDeliverTo?: boolean;
    /**
     * Branch contact information (partial)
     * @type {UpdateContactInfoDto}
     * @memberof AdminUpdateBranchDto
     */
    contactInfo?: UpdateContactInfoDto;
}


/**
 * @export
 */
export const AdminUpdateBranchDtoCurrencyEnum = {
    Egp: 'EGP',
    Sar: 'SAR',
    Mad: 'MAD'
} as const;
export type AdminUpdateBranchDtoCurrencyEnum = typeof AdminUpdateBranchDtoCurrencyEnum[keyof typeof AdminUpdateBranchDtoCurrencyEnum];


/**
 * Check if a given object implements the AdminUpdateBranchDto interface.
 */
export function instanceOfAdminUpdateBranchDto(value: object): value is AdminUpdateBranchDto {
    return true;
}

export function AdminUpdateBranchDtoFromJSON(json: any): AdminUpdateBranchDto {
    return AdminUpdateBranchDtoFromJSONTyped(json, false);
}

export function AdminUpdateBranchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateBranchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'canDeliverTo': json['canDeliverTo'] == null ? undefined : json['canDeliverTo'],
        'contactInfo': json['contactInfo'] == null ? undefined : UpdateContactInfoDtoFromJSON(json['contactInfo']),
    };
}

export function AdminUpdateBranchDtoToJSON(value?: AdminUpdateBranchDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'branchName': value['branchName'],
        'currency': value['currency'],
        'canDeliverTo': value['canDeliverTo'],
        'contactInfo': UpdateContactInfoDtoToJSON(value['contactInfo']),
    };
}

